import { getLeadSession, saveLeadAnswer } from './lead-session';

export const initSurvey = (): void => {
	const survey = document.querySelector<HTMLElement>('[data-survey]');
	if (!survey) return;

	const session = getLeadSession();
	const token = session?.token ?? '';

	survey
		.querySelectorAll<HTMLElement>('[data-survey-question]')
		.forEach((question) => {
			const key = question.dataset.surveyQuestion ?? '';
			const chips =
				question.querySelectorAll<HTMLButtonElement>('[data-answer]');
			const saved = session?.answers[key];

			chips.forEach((chip) => {
				if (saved) {
					chip.setAttribute(
						'aria-pressed',
						String(chip.dataset.answer === saved),
					);
				}

				chip.addEventListener('click', () => {
					chips.forEach((other) =>
						other.setAttribute('aria-pressed', String(other === chip)),
					);

					const answer = chip.dataset.answer ?? '';
					saveLeadAnswer(key, answer);
					if (!token) return;

					const body = new FormData();
					body.append('action', 'mlarlive_lead_survey');
					body.append('nonce', survey.dataset.nonce ?? '');
					body.append('page_id', survey.dataset.pageId ?? '');
					body.append('token', token);
					body.append('key', key);
					body.append('answer', answer);

					fetch(survey.dataset.ajaxUrl ?? '', { body, method: 'POST' }).catch(
						() => {},
					);
				});
			});
		});
};
